import ModalDangerButtons from 'shared/components/modals/ModalDangerButtons';
import AlertModal from 'shared/components/modals/AlertModal';
import FormError from 'shared/components/FormError';
import {observer} from 'mobx-react';

const RemoveModal = observer(({onHide, isOpen, onConfirm, header, subHeader, body, saveCaption, disabled, error}) => {
  return (
    <AlertModal mode='danger' size='sm'
                header={header}
                subHeader={subHeader}
                body={body}
                onHide={onHide} isOpen={isOpen}>
      <FormError message={error}/>
      <ModalDangerButtons saveCaption={saveCaption} onCancel={onHide} onSave={onConfirm} disabled={disabled}/>
    </AlertModal>
  );
});

RemoveModal.defaultProps = {
  saveCaption: 'Remove'
};

export default RemoveModal;
